export class SeguridadDocenteModel {
    constructor(
        public DOCENTE: string,
        public NOMBRES: string,
        public TIPO_DOCUMENTO: string,
        public NRO_DOCUMENTO: string,
        public EMAIL: string,
        public ES_DOCENTE: boolean,
        public ES_TUTOR: boolean
    ) { }
}



// WEBPACK FOOTER //
// C:/Users/egila/Downloads/temp/20260608_NuevoSAT/Trilce.Presentacion.Intranet.Profesores.NG5/src/app/support/model/seguridad.docente.model.ts